import React, { memo, useState } from "react";
import PropTypes from "prop-types";
import { validators } from "investira.sdk";
import {
  Persona,
  Stack,
  Typography,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Icon,
  IconButton,
  Chip,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
} from "investira.react.components";

import withResponseHandling from "../../hoc/withResponseHandling";
import withMessage from "../../hoc/withMessage";
import { USUARIO_PERFIL } from "../../enums";
import EntidadeMembroConfirmDelete from "./EntidadeMembroConfirmDelete";

const Membros = memo((props) => {
  const {
    membro,
    acesso,
    currentUsuarioPerfil,
    currentUsuarioId,
    setSeletecUser,
    onDeleteClick,
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);

  const open = Boolean(anchorEl);

  const isSuperUser = membro.perfil === "sp";

  const showActions = USUARIO_PERFIL[currentUsuarioPerfil].prioridade <= 2;
  const isCurrentAdmin = currentUsuarioId === membro.usuario_id;

  function handleMenuOpen(pEvent) {
    setAnchorEl(pEvent.currentTarget);
  }

  function handleMenuClose() {
    setAnchorEl(null);
  }

  function handleDeleteClick(pUsername, pUsuarioId) {
    handleMenuClose();
    setOpenDeleteConfirm(true);
    //onDeleteClick({ username: pUsername, usuario_id: pUsuarioId });
  }

  function defaultAcesso(pPerfil) {
    return {
      RLENQ: pPerfil === "cs" ? "C" : null,
      RLVAR: pPerfil === "cs" ? "C" : null,
      RLDUR: pPerfil === "cs" ? "C" : null,
      RLSTT: pPerfil === "cs" ? "C" : null,
      RLBCK: pPerfil === "cs" ? "C" : null,
      RLCRL: pPerfil === "cs" ? "C" : null,
      RLFEF: pPerfil === "cs" ? "C" : null,
      RLCNC: pPerfil === "cs" ? "C" : null,
    };
  }

  function handlePromoveClick(pUsuarioId, pPerfil = "ad") {
    handleMenuClose();
    props.onModifyClick({
      usuario_id: pUsuarioId,
      perfil: pPerfil,
      acesso: defaultAcesso(pPerfil),
    });
  }

  return (
    <ListItem
      key={membro.username}
      sx={{ borderRadius: 2 }}
      secondaryAction={
        showActions && !isCurrentAdmin && !isSuperUser ? (
          <IconButton edge="end" onClick={handleMenuOpen}>
            <Icon iconName="others" />
          </IconButton>
        ) : null
      }
    >
      <ListItemAvatar>
        <Persona alt={membro.name} />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="body1" color="textPrimary">
              {membro.name || membro.username}
            </Typography>
            <Stack direction="row" spacing={1} sx={{ pr: 2 }}>
              <span>
                <Chip
                  variant="outlined"
                  size="small"
                  color="secondary"
                  label={
                    USUARIO_PERFIL[membro.perfil]?.descricao || "Convidado"
                  }
                  icon={
                    USUARIO_PERFIL[membro.perfil]?.prioridade <= 2 ? (
                      <Icon iconName="user_tie" size={14} color="secondary" />
                    ) : (
                      <Icon iconName="user" size={14} color="secondary" />
                    )
                  }
                  sx={{
                    px: 1,
                    "& svg": {
                      fill: "var(--color-secondary-lightness) ",
                    },
                  }}
                />
              </span>

              {membro.status === "N" && (
                <Chip size="small" color="warning" label={"Novo"} />
              )}
            </Stack>
          </Stack>
        }
        secondary={
          membro.name && (
            <Typography variant="caption" color="textSecondary">
              {membro.username}
            </Typography>
          )
        }
      />
      <Menu
        id={`entidade-menu`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
      >
        {acesso &&
          USUARIO_PERFIL[membro.perfil]?.prioridade < 9 &&
          USUARIO_PERFIL[membro.perfil]?.prioridade > 0 && (
            <>
              <MenuItem
                onClick={() => {
                  setSeletecUser(membro);
                  handleMenuClose();
                }}
              >
                <ListItemIcon>
                  <Icon iconName="toll" size={16} />
                </ListItemIcon>
                <ListItemText>Definir Acessos</ListItemText>
              </MenuItem>
              <Divider />
            </>
          )}

        {USUARIO_PERFIL[membro.perfil]?.prioridade >= 2 && (
          <>
            {membro.perfil !== USUARIO_PERFIL.ad.id && (
              <MenuItem
                onClick={() =>
                  handlePromoveClick(membro.usuario_id, USUARIO_PERFIL.ad.id)
                }
              >
                <ListItemIcon>
                  <Icon iconName="user_tie" size={16} />
                </ListItemIcon>
                <ListItemText>
                  Alterar para {USUARIO_PERFIL.ad.descricao}
                </ListItemText>
              </MenuItem>
            )}

            {membro.perfil !== USUARIO_PERFIL.op.id && (
              <MenuItem
                onClick={() =>
                  handlePromoveClick(membro.usuario_id, USUARIO_PERFIL.op.id)
                }
              >
                <ListItemIcon>
                  <Icon iconName="user" size={16} />
                </ListItemIcon>
                <ListItemText>
                  Alterar para {USUARIO_PERFIL.op.descricao}
                </ListItemText>
              </MenuItem>
            )}

            {membro.perfil !== USUARIO_PERFIL.us.id && (
              <MenuItem
                onClick={() =>
                  handlePromoveClick(membro.usuario_id, USUARIO_PERFIL.us.id)
                }
              >
                <ListItemIcon>
                  <Icon iconName="user" size={16} />
                </ListItemIcon>
                <ListItemText>
                  Alterar para {USUARIO_PERFIL.us.descricao}
                </ListItemText>
              </MenuItem>
            )}

            {membro.perfil !== USUARIO_PERFIL.cs.id && (
              <MenuItem
                onClick={() =>
                  handlePromoveClick(membro.usuario_id, USUARIO_PERFIL.cs.id)
                }
              >
                <ListItemIcon>
                  <Icon iconName="user" size={16} />
                </ListItemIcon>
                <ListItemText>
                  Alterar para {USUARIO_PERFIL.cs.descricao}
                </ListItemText>
              </MenuItem>
            )}
            <Divider />
          </>
        )}

        {/* {isAdmin && props.adminSize > 1 && (
          <MenuItem onClick={() => handleDegradeClick(membro.usuario_id)}>
            <ListItemIcon>
              <Icon iconName="user" size={16} />
            </ListItemIcon>
            <ListItemText>Rebaixar para usuário</ListItemText>
          </MenuItem>
        )} */}

        {/* {!isAdmin && <Divider />} */}
        {!isCurrentAdmin && (
          <MenuItem onClick={() => handleDeleteClick(membro.username)}>
            <ListItemIcon>
              <Icon iconName="delete" size={16} color="error" />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ color: "error" }}>
              Excluir
            </ListItemText>
          </MenuItem>
        )}
      </Menu>
      <EntidadeMembroConfirmDelete
        open={openDeleteConfirm}
        membro={membro}
        onDelete={onDeleteClick}
        onClose={() => setOpenDeleteConfirm(false)}
      />
    </ListItem>
  );
});

Membros.propTypes = {};

export default withResponseHandling(withMessage(Membros));
